import {Badge, BadgeProps, Tooltip} from '@mui/material';

type GenericSidebarItemBadgeProps = {
  children: React.ReactNode;
} & BadgeProps;

export type GenericSidebarItemBadgeComponent =
  React.ComponentType<GenericSidebarItemBadgeProps>;

type Props = GenericSidebarItemBadgeProps & {
  tooltipContent?: string;
  badgeColor?: string;
};

export const SidebarItemBadge = ({
  tooltipContent,
  badgeColor,
  ...props
}: Props) => {
  const hasBadgeContent = Boolean(props.badgeContent);

  const badge = (
    <Badge
      color="secondary"
      badgeContent={props.badgeContent}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      overlap="circular"
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor: badgeColor ?? 'error.main',
          padding: '1px',
          transform: 'scale(0.75) translate(-50%, -50%)',
          left: '-1px',
          top: '-1px',
          transition: 'transform 0.2s ease-in-out, opacity 0.2s ease-in-out',
          ...(!hasBadgeContent && {
            transform: 'scale(0) translate(-50%, -50%)',
            opacity: 0,
          }),
        },
      }}
      {...props}
    >
      {props.children}
    </Badge>
  );

  if (!tooltipContent || !hasBadgeContent) {
    return badge;
  }

  return (
    <Tooltip title={tooltipContent} placement="bottom" arrow>
      {badge}
    </Tooltip>
  );
};
